import React from 'react';
import './Styles/Banner.scss';

const Banner=()=>{
    return(
        <div className="resources-banner">
            <h1>Resources Hub</h1>
            <p>A library of educational gems that’ll get you up to speed with all things Marvel</p>
        </div>
    )
};
export default Banner ;